export default {
  common: {
    email: 'Email',
    phone: 'Phone',
    phoneNumber: 'Phone Number',
    countrySelect: 'Choose the country',
    countryUnmodifiedNote: 'Country cannot be modified after registration',
    next: 'Next',
    back: 'Back',
    attention: 'Attention',
    cancel: 'Cancel',
    confirm: 'Confirm',
    modify: 'Modify',
    ignore: 'Ignore',
    firstName: 'First Name',
    middleName: 'Middle Name',
    lastName: 'Last Name',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    birthday: 'Birthday',
    graphicCode: 'Graphic Code',
    emailCode: 'Email Verification Code',
    smsCode: 'SMS Code',
    smsVerificationCode: 'SMS verification code',
    bind: 'Bind',
    send: 'Send',
    resend: 'Resend',
    address: 'Address',
    done: 'Done',
    systemMessage: 'System Message',
    setting: 'Setting',
    submit: 'Submit',
    language: 'Language',
    edit: 'Edit',
    delete: 'Delete'
  },
  account: {
    account: 'Account',
    nickname: 'Nickname',
    id: 'ID',
    basicInfo: 'Basic Level',
    placeholder: 'Please enter',
    completed: 'Completed',
    semiInfo: 'Semi-Verified',
    fullyInfo: 'Fully-Verified',
    basicTab: 'Basic',
    advancedTab: 'Advanced',
    linkedAccount: 'Linked Withdrawal Account',
    accountSecurity: 'MetWallet Account and Safety',
    logout: 'Log Out',
    semiToast: 'Please complete Basic-Level verification',
    fullyToast: 'Please complete Basic-Level \n and Semi-Verified',
    quickLoginTitle: 'Quick Login',
    cancelQuickLogin: 'Are you sure to disable the Quick Login?'
  },
  accountSecurity: {
    title: 'Account and Safety',
    payPwd: 'Payment Password',
    loginPwd: 'Login Password',
    changeEmail: 'Change Email',
    changePhone: 'Change Phone Number',
    changePayPwd: 'Change Payment Password',
    changeLoginPwd: 'Change Login Password',
    bindEmail: 'Bind Email',
    bindEmailNote: 'Pass Email verification to bind it',
    bindEmailPlaceholder: 'Enter the Email you want to bind',
    smsBindNote: 'Pass SMS verification to bind it',
    bindPhone: 'Bind Phone Number',
    smsAuthentication: 'SMS Authentication',
    emailAuthentication: 'Email Authentication',
    phoneVerificationNote: 'Pass current phone number verification first',
    bindPhonePlaceholder: 'Enter the phone number you want to bind',
    verificationWrongToast: 'Please check your verification code',
    phoneNumberEmptyToast: 'Please fill the phone number',
    verificationCodeEmptyToast: 'Please fill in the code',
    wrongCodeToast: 'Wrong code',
    changeNote: 'Please pass the verification to change it.',
    newEmailVerification: 'New Email Verification',
    newEmailPlaceholder: 'Enter your new Email',
    change: 'Change',
    emailLowercaseToast: 'Email should be in lowercased letters.',
    newEmailEmptyToast: 'Please fill new email',
    changeSuccessToast: 'Change successfully',
    phonePlaceholder: 'Enter phone',
    currentEmail: 'Current Email',
    passCurrentEmailVerificationFirst: 'Pass current Email verification first',
    currentEmailVerification: 'Current Email Verification',
    smsVerification: 'SMS Verification',
    currentPhoneNumber: 'Current Phone Number',
    currentPhoneVerification: 'Current Phone Verification',
    currentEmailAddress: 'Current Email Address',
    phoneVerification: 'Phone Verification',
    enterVerificationCode: 'Enter the verification code',
    newPhoneNumber: 'New Phone Number',
    newEmail: 'New Email'
  },
  withdrawAccount: {
    selectAccountType: 'Select Account Type',
    noBasicLevelVerificationDialog: 'Please complete the Basic Level verification before binding the cash out method.',
    bindNote: 'Please fill in the correct account information, or your withdrawal will be affected.',
    bindBankAccount: 'Bind Bank Account',
    bindMobileMoneyAccount: 'Bind Mobile Money Account',
    fieldEmptyToast: '{0} is required',
    fieldLengthToast: 'The {0} must contain at least {1} characters',
    bindBankRepeatToast: 'Do not bind the same bank account repeatedly!',
    accountName: 'Account Name',
    ifscCode: 'IFSC Code',
    accountEmptyToast: 'Account is required',
    accountNameEmptyToast: 'Account Name is required',
    phoneEmptyToast: 'Phone is required',
    emailEmptyToast: 'Email is required',
    ifscCodeEmptyToast: 'IFSC Code is required',
    ifscCodeLengthToast: 'IFSC Code must be 11 digits',
    bindIMPSRepeatToast: 'Do not bind the same IMPS account repeatedly!',
    bindNote2:
      'Please fill in your correct TRC-20 address. A wrong address will cause the payment lost, which we do not take any responsibility.',
    usdtAddress: 'USDT address(TRC-20):',
    minimumLimit: 'Withdrawal minimum for per transaction: $10',
    usdtFee: 'Fee: Subject to the actual fees',
    registerGcash: "If you don't have Gcash account, please click here to register.",
    registerEpay: "If you don't have Epay account, please click here to register.",
    bindThirdPartyTitle: 'Bind {0} Account',
    wrongAccountToast: 'Wrong account',
    accountFormatToast: 'Account format is incorrect',
    bindThirdPartyFailedToast: '{0} binding failed',
    queryFailedToast: 'Query Failed.',
    editFailedToast: 'Failed Edit.',
    add: 'Add',
    confirmEditDialog: 'Are you sure to edit the account {0}?',
    payPwdRequireDialog: 'Please set a 6-digit payment password before adding an account.',
    unbindFailedToast: 'Unbinding failed',
    cashOutSuccessNote: 'Estimated Arrival Time: within 7 working days',
    requestSubmitted: 'Withdrawal Request Submitted',
    amountLimitToast1: 'The cash out amount must be ≥$40.00',
    // eslint-disable-next-line no-template-curly-in-string
    amountLimitToast2: 'The cash out amount must be ≥${0}.00',
    recommendAmountNote:
      // eslint-disable-next-line no-template-curly-in-string
      'Tips: Accumulating the amount to ${0} before withdrawing will effectively save your processing fees.',
    amountNotEnoughToast: 'The cash out amount is not enough',
    exceedingLimitToast1: 'The cash out amount today has reached the upper limit',
    exceedingLimitToast2:
      'The cash out amount today has reached the upper limit. Do you need to complete the advanced certification to raise the limit?',
    restrictedCountriesPayPalAccountToast:
      'Do not use a restricted countries PayPal account, which will cause your Arripay blocked',
    withdrawMinimumToast: 'Withdrawal minimum for per transaction:$40',
    bankNotAvailableToast: 'This bank is no longer available, please bind other banks.',
    usdtAccountInvalidToast: 'This USDT account is unable to withdraw, please use a new account for withdrawal.',
    noPayPwdToast: 'Please set a 6-digit payment password before cash-out.',
    editBankAccount: 'Edit Bank Account',
    accountPlaceholder: 'Enter your account',
    trc20Placeholder: 'enter the TRC-20 address',
    accountRepeatToast: 'The same as the current one.',
    unbindBankCardConfirmDialog: 'Are you sure to unbind the bank card {0}?',
    unbindMobileMoneyAccountConfirmDialog: 'Are you sure to unbind the mobile money account {0}?',
    unbindAccountConfirmDialog: 'Are you sure to unbind the account {0}?',
    availableBalance: 'Available balance {0}',
    estimatedFee: 'Estimated fee',
    submitFailToast: 'Submit failed',
    disabledMethodToast: 'This channel is temporarily unavailable',
    channelUnavailableTitle: 'Channel unavailable',
    channelUnavailableNote: 'This withdrawal channel is temporarily unavailable. Please try another way.',
    channelUnavailableOk: 'OK',
    bankTransferUnavailableTitle: 'Bank Transfer unavailable',
    bankTransferUnavailableNote:
      "Bank Transfer isn't available for your account right now. Please use Epay to withdraw.",
    channelMaintenanceTitle: 'Channel under maintenance',
    channelMaintenanceNote: 'This withdrawal channel is under maintenance. Please try another way.',
    bankInfoUpdateTitle: 'Update your bank info',
    bankInfoUpdateNote: 'Due to the policy adjustment of Bank, please update your bank details to continue.',
    bindEpay: 'Bind Epay',
    useEpay: 'Use Epay',
    iMPSMaxLimitToast: 'The maximum withdrawal amount for a single transaction through this channel is $260',
    linkedAccount: 'Account added',
    otherAccounts: 'Other accounts can be added',
    withdrawTo: 'Transfer to',
    withdrawAmount: 'Transfer amount',
    withdrawable: 'Withdrawable',
    documentIdToast: 'Document ID can contain only numbers',
    noAvailableMethodNote: 'No available withdrawal method',
    channelFee: 'Fee：{0}',
    recommended: 'Recommended'
  },
  paymentCode: {
    changePayPwd: 'Change Payment Password',
    setPayPwd: 'Set Payment Password',
    setPayPwdNote: 'Please set 6-digit payment password',
    reenterPayPwdNote: 'Enter again',
    verificationNote: 'Please pass the verification to set it.',
    verifyToSetPayPwd: 'Verify to set the payment password.',
    emailVerification: 'Email Verification',
    inconsistentPasswordToast: 'Inconsistent password',
    payPwdNote: 'Please enter the payment password',
    payPwdFormatToast: 'Payment password is a 6-digit number',
    payPwdWrongToast: 'Wrong payment password',
    payPwdVerificationFailToast: 'Payment password verification failed!',
    successToast: 'Set \n successfully'
  },
  authorize: {
    requirement:
      '{0} needs to acquire the following information of your MetWallet{1} to provide related service for you. Nickname, Avatar, Gender etc.',
    authorize: 'Authorize',
    switchAccount: 'Switch Account',
    goToMetWallet: 'Go to MetWallet',
    enableQuickLogin: 'Enable Quick Login',
    notMatchTips: 'Operation failed. You can only enable Quick Login with your bound MetWallet account'
  },
  basicLevel: {
    namePlaceholder: 'No symbols, numbers',
    verification: 'Verification',
    whatsAvailable: "What's available",
    cashOut: 'Cash Out',
    withdrawTitle: 'Withdraw',
    withdrawLimit: '$50 Per Day',
    fillInfoHint: 'Fill in the info to withdraw',
    identityVerification: 'Identity Verification',
    withdrawalAccountStep: 'Withdrawal Account',
    nameMatchNote: 'Make sure the name matches your bank card, or the withdrawal will fail.',
    nameFieldPlaceholder: 'Name',
    birthdayPlaceholder: 'Date of birthday',
    addressPlaceholder: 'Enter the address',
    emailRegisteredNote: 'This email has been registered. Please change one.',
    basicLevelNote:
      'Please enter your real personal information and it is not allowed to modify. Wrong information may cause failed withdrawal.',
    fieldEmptyToast: 'Please fill in all required fields.',
    successToast: 'Saved \n successfully',
    failToast: 'Save failed',
    confirmDialog: 'Ensure enter your real personal information. Wrong information may cause failed withdrawal.',
    birthdayFormatToast: 'Incorrect Birthday field format',
    verificationCodeError: 'Verification code error',
    verificationCodeEmpty: 'Verification code empty',
    noEmailCodeToast: 'Please get the email verification code',
    confirmInfoTitle: 'Confirm Info',
    confirmInfoWarning:
      '*Name must match your bank card exactly, or withdrawals may fail. Not editable after submission.',
    saveCountdown: 'Save({0}s)',
    saveInfo: 'Save',
    checkDialogTitle: 'Check your info',
    checkDialogContent:
      'To withdraw successfully, please check your information. Wrong info may cause failed withdrawal.',
    check: 'Check'
  },
  semiVerified: {
    uploadPhotoId: 'Upload Photo ID',
    photoId: 'Photo ID',
    resubmit: 'Resubmit',
    limit: '$5,000 Per Day',
    uploading: 'Uploading...',
    notUploadProofToast: 'Please upload a proof of ID card'
  },
  fullyVerified: {
    frontOfId: 'Front of ID',
    backOfId: 'Back of ID',
    uploadIdFront: 'Upload ID Front',
    uploadIdBack: 'Upload ID Back',
    withdrawDailyHint: 'Fill in the info to withdraw > {0} a day.',
    notUploadIdToast: 'Please upload the front and back of your ID',
    proofTitle: 'PROOF OF RESIDENCE DOCUMENT',
    acceptableProof: 'AN ACCEPTABLE PROOF OF RESIDENCE IS:',
    acceptableProof1: 'A bank account statement.',
    acceptableProof2: 'A utility bill (electricity, water, internet, etc.).',
    acceptableProof3: 'A government-issued document (tax statement, certificate of residency, etc.).',
    unacceptableProof:
      'We cannot accept the address on your submitted identity document as a valid proof of residence.',
    limit: '$10,000 Per Day',
    notUploadToast: 'Please upload a proof of residence document',
    incorrectFormatToast: 'Please upload jpg/png/jpeg picture.'
  },
  loginAndRegister: {
    pwd: 'Password',
    lastLogin: 'Last Login',
    moreOptions: 'More Options',
    agreeCheckboxContent: 'Agree to {0} and {1}',
    userAgreement: 'User Agreement',
    privacyPolicy: 'Privacy Policy',
    notAgreeToast: 'Agree to User Agreement and Privacy Policy',
    forgotPassword: 'Forgot Password',
    linkedMail: 'Linked Mail',
    verificationCode: 'Verification Code',
    newPwd: 'New Password',
    repeatPwd: 'Repeat Password',
    confirmPwd: 'Confirm Password',
    noLinkedEmailToast: 'No linked Email with your account',
    unregisteredToast: "This number hasn't been registered",
    pwdFormatToast: "Password's format is wrong",
    resetSuccessToast: 'Reset \n successfully',
    pwdNotMatchToast: 'Passwords do not match twice',
    emailFormatToast: 'Wrong Email Format',
    phoneNumberFormatToast: 'Wrong phone number format',
    invalidAreaCodeToast: 'Invalid areacode',
    login: 'Log in',
    pwdLogin: 'Log in via password',
    emailCodeLogin: 'Log in via Email verification code',
    smsLogin: 'Log in via SMS',
    verifyEmail: 'Verify Email',
    verifyPhone: 'Verify Phone',
    accountDangerDialog:
      'Your account has been detected with danger. Please re-verify your account, otherwise your account will not be able to continue to be used.',
    sendEmailCodeDialog: 'We have sent a verification code to your {0} email. Please enter the verification code.',
    sendSmsCodeDialog: 'We have sent a verification code to your {0} phone. Please enter the verification code.',
    graphicCodeEmptyToast: 'Please enter the graphic code.',
    countryUnselectToast: 'Please choose your country first',
    unsupportedLoginTypeToast: 'Unsupported login type',
    pwdWrongLimitOverDialog:
      'The wrong password has been entered 3 times. Please use the SMS verification code to log in.',
    loginFailedToast: 'Login failed',
    signIn: 'Sign in',
    pwdPlaceholder: 'Enter the password',
    pwdNote: 'Enter 8-16 characters that include letters and numbers',
    reenterPwdPlaceholder: 'Re-enter the password',
    reenterPwdNote: 'Please re-enter the password',
    createAccount: 'Create Account',
    chooseCountryNote: 'Please choose the country',
    pwdInconsistentToast: 'Not the same with the previous password you entered',
    createSuccessToast: 'Create \n successfully',
    registerFailToast: 'Register failed',
    userNotExistToast: 'User does not exist',
    phoneIncorrectToast: 'Please check your phone',
    userExistToast: 'The user already exists',
    countryCodeRepeatToast: 'Please do not enter the country code repeatedly!',
    logoutDialog: 'Are you sure to log out?',
    pwdRequirement: 'Password must be at least 8 to 16 characters with letters and numbers',
    signup: 'Sign Up',
    registerSuccessToast: 'Register \n successfully',
    oldPwdErrorToast: 'Please check your old password'
  },
  checkUserInfo: {
    title: 'Management Center',
    emptyInfoNote:
      'Here is no information for the current account, please check the MetWallet account you need to verify.',
    infoNote: 'Here is your verification information.',
    lastSuccessWithdrawal: 'Last successful withdrawal',
    copyBtn: 'Copy',
    successToast: 'Copied Successfully!',
    failToast: 'Failed to copy!'
  },
  country: {
    title: 'Select Region',
    popular: 'Popular'
  },
  documentDetails: {
    title: 'Document Details',
    contract: 'Contract',
    goToSign: 'Go to sign it',
    download: 'Download',
    upload: 'Upload',
    fileTypeLimit: 'doc., pdf., xlsx., xls., png., jpg., jpeg., documents only.',
    contentEmptyToast: 'Please enter the content',
    placeOfBirth: 'Place of Birth',
    occupation: 'Occupation',
    fileForm: '(File Form)',
    proofOfAddress: 'Proof of Address in English',
    residenceDoc: 'Residence Document',
    textForm: '(Text Form)',
    contractAgent: 'Contract Agent',
    contractPayslip: 'Contract Payslip',
    uncompletedToast: 'Please complete it to submit',
    successToast: 'Submit Successfully',
    undefinedFileTypeToast: 'Undefined file upload type',
    uploadFailToast: 'Upload failed'
  },
  filters: {
    amount: 'Amount',
    filter: 'Filters',
    time: 'Time',
    reset: 'Reset',
    timePickerTitle: 'Select {0} Time',
    start: 'Start',
    end: 'End',
    maximum: 'Maximum',
    minimum: 'Minimum'
  },
  home: {
    balance: 'Balance',
    transactions: 'Transactions',
    availableBalance: 'Available Balance',
    noWithdrawalMethodToast: 'At least one withdrawal method is needed.',
    linkAccount: 'Link Account',
    all: 'All',
    cashIn: 'Cash In',
    loading: 'loading...',
    noMore: 'No more transactions',
    reload: 'Loading failed, click to reload',
    receivedFrom: 'Received from',
    transferredTo: 'Transferred to',
    fee: 'Fee for transferring to',
    myEmail: 'My Email',
    myPhone: 'My Phone',
    invalidBasicLevelDialog:
      'Due to the inclusion of symbols, spaces, or numbers in your name field, withdrawal from the account is not possible. Please fill in the basic information again(ensure that the name does not include symbols, spaces, or numbers and if you have no family or middle name, just leave it blank.)',
    lackLastNameDialog: 'Your Last Name is not filled in, which will hinder your withdrawal.',
    fillIn: 'Fill in',
    viewDetails: 'View Details',
    docReviewingDialogTitle: 'Please wait for the document being passed.',
    docReviewingDialogContent:
      'You have submitted the document, but you cannot use MetWallet before your document is passed.<br>Official staff will process it soon, please wait for a while.',
    docPassedDialog: 'The document you submitted is passed. <br>You can use MetWallet normally now.',
    docUnqualifiedDialog: 'The document you submitted is unqualified. <br>Please submit a qualified one.',
    goToSubmit: 'Go to submit it',
    uncompletedDialog: 'You must complete it to use MetWallet normally',
    useMetWalletNormallyAfterPassed: 'You can use MetWallet normally after the document is passed.',
    requireSemiVerifiedDialog:
      "{0}, for bank's requirement, you have to finish semi-verified part in 48 hours for successful withdrawal.",
    goToVerify: 'Go To Verify',
    emailInvalidDialog:
      "{0}, your e-mail address is the same as another person's. For privacy insurance, please enter your own e-mail address as soon as possible.",
    later: 'Later',
    transferRequireSemiVerifiedDialog: 'Please complete the Semi-Verified verification before transfer.',
    modifyBtnText: 'Modify My Info',
    unmodifiedTitle: 'Unable to modify',
    unmodifiedContent: 'You have a withdrawal order in process. Information cannot be modified now.'
  },
  signing: {
    signature: 'Signature',
    date: 'Date',
    employeeName: 'Employee Name',
    designation: 'Designation',
    month: 'Month',
    year: 'Year',
    earnings: 'Earnings',
    deductions: 'Deductions',
    basic: 'Basic & DA(USD)',
    totalAddition: 'Total Addition',
    totalDeduction: 'Total Deduction',
    salary: 'NET Salary',
    refNo: 'Ref No',
    paymentTransferDate: 'Payment Transfer Date',
    nameOfBank: 'Name of Bank',
    signatureOfEmployee: 'Signature of the Employee',
    director: 'Director',
    signNote: 'Please sign your name',
    preview: 'Preview',
    clear: 'Clear',
    save: 'Save',
    noSignatureToast: 'You cannot save without a signature.',
    fieldEmptyToast: 'Please fill in all the information.'
  },
  transactionDetail: {
    title: 'Transaction Detail',
    status: 'Status',
    pending: 'Pending',
    completed: 'Completed',
    success: 'SUCCESS',
    failed: 'Failed',
    cancelled: 'Cancelled',
    onHold: 'On Hold',
    reason: 'Status Reason',
    description: 'Description',
    creationDate: 'Creation date',
    lastStatusDate: 'Last status date',
    requestedAmount: 'Requested amount',
    receiveAmount: 'Receive amount',
    transferAmount: 'Transfer amount',
    amountToPay: 'Amount to pay',
    transferFee: 'Transfer fee',
    processingFee: 'Processing fee',
    method: 'Method',
    country: 'Country',
    name: 'Name',
    bankPendingText: 'Under final bank review',
    pendingText: 'Under {0} review',
    chametSalary: 'Chamet salary',
    userSalary: 'User salary',
    comm: 'Comm.',
    gemgalaSalary: 'Gemgala salary'
  },
  transfer: {
    title: 'To MetWallet Account',
    noPayPwdDialog: 'Please set a 6-digit payment password before transfer.',
    records: 'Records',
    cashInOut: 'Cash in {0}, Cash out {1}',
    transfer: 'Transfer',
    fee: 'Fee',
    remark: 'Remark',
    transferTo: 'Transfer to {0}',
    remarkPlaceholder: 'Add transfer remark(less than 100 characters)',
    firstNameNote: 'Please enter his/her first name',
    sendingAmount: 'Sending Amount',
    receivingAmount: 'Receiving Amount',
    transferNow: 'Transfer Now',
    noBalanceToast: 'Transfer amount is bigger than balance amount.',
    amountTooLittleToast: 'Transfer amount cannot be less than $10.'
  },
  bankData: {
    beneficiaryName: 'Beneficiary Name',
    beneficiaryNamePlaceholder: 'Enter Name',
    beneficiaryLastname: 'Beneficiary Lastname',
    beneficiaryLastnamePlaceholder: 'Enter Lastname',
    bankCode: 'Bank Code',
    bankCodePlaceholder: 'Select Bank Code',
    bankIFSCCode: 'Bank IFSC Code',
    bankIFSCCodePlaceholder: 'Enter Bank IFSC',
    bankAccount: 'Bank Account',
    bankAccountPlaceholder: 'Enter Bank Account',
    email: 'Email',
    emailPlaceholder: 'Enter Email',
    phoneNumber: 'Phone Number',
    phoneNumberPlaceholder: 'Enter Phone Number',
    address: 'Address',
    addressPlaceholder: 'Enter Address',
    city: 'City',
    cityPlaceholder: 'Enter City',
    state: 'State',
    statePlaceholder: 'Enter State',
    postCode: 'Post Code',
    postCodePlaceholder: 'Enter Post Code',
    documentId: 'Document Id',
    documentIdPlaceholder: 'Enter Document Id',
    nationalId: 'National ID',
    nationalIdPlaceholder: 'Enter National ID',
    individualTaxId: 'Individual Tax ID',
    individualTaxIdPlaceholder: 'Enter Individual Tax ID',
    documentType: 'Document Type',
    documentTypePlaceholder: 'Select Document Type',
    accountType: 'Account Type',
    accountTypePlaceholder: 'Select Account Type',
    cpfcnpjPlaceholder: 'Enter CPFCNPJ',
    bankBranch: 'Bank Branch',
    bankBranchPlaceholder: 'Enter Bank Branch',
    ribOfBankAccount: 'RIB of Bank Account',
    bankName: 'Bank Name',
    bankNamePlaceholder: 'Enter Bank Name',
    bicCode: 'BIC code',
    bicCodePlaceholder: 'Enter BIC code',
    ibanPlaceholder: 'Enter IBAN',
    bankSwift: 'Bank Swift',
    bankSwiftPlaceholder: 'Enter Bank Swift',
    name: 'Name',
    documentCountry: 'Document Country',
    documentCountryPlaceholder: 'Select Document Country',
    issueDate: 'Document Issue Date',
    issueDatePlaceholder: 'Select Issue Date',
    expireDate: 'Document Expire Date',
    expireDatePlaceholder: 'Select Expire Date',
    bankBranchName: 'Bank Branch Name',
    bankBranchNamePlaceholder: 'Enter Branch Name',
    branchPlaceholder: 'Enter Branch',
    gender: 'Gender',
    genderPlaceholder: 'Select Gender',
    birthday: 'Birthday',
    birthdayPlaceholder: 'Select Birthday',
    phone: 'Phone',
    bankAddress: 'Bank Address',
    bankAddressPlaceholder: 'Enter Bank Address',
    bankAccountName: 'Bank Account Name',
    bankAccountNamePlaceholder: 'Enter Bank Account Name',
    province: 'Province',
    provincePlaceholder: 'Enter Province',
    postalCode: 'Postal Code',
    postalCodePlaceholder: 'Enter Postal Code',
    savingsAccount: 'Savings Account',
    abaRoutingNumber: 'ABA routing number',
    englandBankAccount: 'England Bank Account',
    bankBranch2: 'bankBranch',
    bankBranch2Placeholder: 'Only if bank is Santander',
    paternalName: 'Paternal Name',
    paternalNamePlaceholder: 'Enter Paternal Name',
    passportIdNumber: 'Passport ID Number',
    bankNamePlaceholder2: 'Select Bank Name',
    areaCode: 'Area Code',
    phoneNumberNoAreaCode: 'Phone Number (No Area Code)',
    idType: 'ID Type',
    idNo: 'ID NO.',
    idIssueDate: 'ID Issue Date',
    idExpireDate: 'ID Expire Date',
    ibanStyleToast: "Please enter content starting with 'SA' with a length of 24 characters."
  },
  rechargeAndTransfer: {
    transfer_limit_1: 'You can only transfer to Diamond Sellers',
    search: 'Search',
    history: 'Transferred users',
    confirm_content: 'Are you sure to transfer {0} to {1}',
    success_content: '{0} has been transferred to {1}',
    purchase: 'Purchase',
    purchase_success: 'You have successfully purchased {0}',
    insufficient_balance: 'Insufficient balance',
    purchase_diamond: 'Purchase Diamonds',
    transfer_limit_2: 'The transfer amount should be between $10 and $30,000',
    no_data: 'No Data',
    invalid_number: 'Please enter a valid number',
    under_limit: 'The transfer amount should be no less than $10',
    over_limit: 'The transfer amount should be less than $30,000'
  },
  redesign: {
    emailPlaceholder: 'Enter email address',
    retrievePwd: 'Retrieve password',
    resetPwd: 'Reset password',
    newPwdPlaceholder: 'Enter new password',
    reenterNewPwdPlaceholder: 'Re-enter new password',
    reenterPayPwdPlaceholder: 'Please re-enter the payment password',
    sendToPhone: 'The verification code has been sent to your phone',
    sendToWhatsapp: 'The verification code has been sent to your WhatsApp',
    sendToEmail: 'The verification code has been sent to your email',
    invalidCode: 'Invalid code',
    userId: 'User ID',
    other: 'Other',
    transactionRecord: 'Transaction Record',
    bankCardInfo: 'Bank card account',
    withdrawInfo: 'Withdrawal account',
    toFillIn: 'To be filled in',
    walletInfo: 'Wallet account',
    toComplete: 'To be completed',
    verifyGuide: 'Complete the wallet account information to obtain more withdrawal qualifications',
    verifyNote: 'Complete the following information to obtain daily withdrawal qualifications of {0}',
    verifyCompletedNote: 'Information is completed to obtain daily withdrawal qualifications of {0}',
    continueBtnText: 'Continue filling in',
    submitInfo: 'Submit information',
    transferAmount: 'Transfer amount',
    newEmailVerify: 'New Email verfication',
    verifyCodePlaceholder: 'Enter the verification code',
    emailIncorrectToast: 'Please enter correct email address',
    newPhone: 'New phone number',
    accountAdded: 'Account information added',
    accountToAdd: 'Other accounts can be added',
    edit: 'Edit',
    enterPayPwd: 'Enter payment password',
    deleteBtnText: 'Delete',
    transferTo: 'Transfer to',
    withdrawable: 'Withdrawable',
    goSet: 'Go set',
    goModify: 'Go modify'
  }
}



// WEBPACK FOOTER //
// ./src/configs/language/lang/en.js